module.exports = __webpack_public_path__ + "static/media/web-application-security.57e714ec.png";